var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.462,
    height: 24.616,
    viewBox: "0 0 18.462 24.616",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1bba45",
    d: "M17.308 0H1.154A1.154 1.154 0 0 0 0 1.154v.769a1.154 1.154 0 0 0 1.154 1.154c0 4.373 2.453 8.064 5.81 9.231-3.357 1.167-5.81 4.858-5.81 9.231A1.154 1.154 0 0 0 0 22.693v.769a1.154 1.154 0 0 0 1.154 1.154h16.154a1.154 1.154 0 0 0 1.154-1.154v-.769a1.154 1.154 0 0 0-1.154-1.154c0-4.373-2.453-8.064-5.81-9.231 3.357-1.167 5.81-4.858 5.81-9.231a1.154 1.154 0 0 0 1.154-1.154v-.769A1.154 1.154 0 0 0 17.308 0zm-3.077 21.539h-10c0-3.724 2.221-6.923 5-6.923s5 3.198 5 6.923z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.bbb9c2ee9b48307f24c7e81fde33d3d0.svg";
export { ForwardRef as ReactComponent };